<template>
  <div class="listmode">
    <a-table :columns="columns"
             :row-key="(record) => record.id"
             :data-source="dataList"
             :pagination="pagination"
             :loading="loading" @change="handleTableChange"
             :locale="locale"

    >
      <div slot="titles" slot-scope="text, arr" style="display: flex">
<!--        <img :src="arr.img" alt="" />-->
        <p style="width: 45vh" class="titletxt">
          <span style="
              cursor: pointer;
              color: #576b95;
              font-weight: 550;
            " @click="titles(arr)">{{ arr.title }}</span>
        </p>
      </div>
      <span slot="createAt" slot-scope="createAt">
        {{formatDate(createAt)}}
      </span>
      <span slot="status" slot-scope="text, arr">
        {{statusText[arr.status]}}
      </span>
      <span slot="operation" slot-scope="text, record">
        <a-popconfirm title="确定发布该稿件嘛?" ok-text="是" cancel-text="否"
                      overlayClassName='popUpStatus3'
                      @confirm="release(text, record)" @cancel="cancel" v-if="record.status==0">
          <span style="cursor: pointer" :style="{color:tableStatus=='workbench'?'#106AFF':'#666666'}">发布</span>
        </a-popconfirm>
        <span style="cursor: pointer;margin: 0 1rem" @click="edit(text, record)" v-if="record.status==0||record.status==2" :style="{color:tableStatus=='workbench'?'#106AFF':'#666666'}">编辑</span>
        <a-popconfirm title="确定删除该稿件嘛?" ok-text="是" cancel-text="否"
                      overlayClassName='popUpStatus3'
                      @confirm="back(text, record)" @cancel="cancel" v-if="record.status==0">
          <span style="cursor: pointer" :style="{color:tableStatus=='workbench'?'#106AFF':'#666666'}">删除</span>
        </a-popconfirm>
        <a-popconfirm title="确定撤回该稿件嘛?" ok-text="是" cancel-text="否"
                      overlayClassName='popUpStatus3'
                      @confirm="back(text, record)" @cancel="cancel" v-else>
<!--          <span v-if="record.status==0" style="cursor: pointer" :style="{color:tableStatus=='workbench'?'#106AFF':'#666666'}">删除</span>-->
          <span style="cursor: pointer" :style="{color:tableStatus=='workbench'?'#106AFF':'#666666'}">撤回</span>
        </a-popconfirm>
      </span>
    </a-table>
    <detailss v-if="detailsshow" :detailssnum="detailssnum" @visible="visible" />
  </div>
</template>

<script>
import { createArticle, deleteArticle, updateArticle, getArticleInfo } from '@/api/article'
import moment from 'moment';
export default {
name: "index",
  props:{
    columns:{
      type: Array,
      default: function () {
        return [];
      },
    },
    dataList:{
      type: Array,
      default: function () {
        return [];
      },
    },
    pagination: {
      type: Object,
      default: function () {
        return {};
      },
    },
    loading: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    tableStatus:{
      type: String,
      default: function (){
        return 'default'
      }
    }
  },
  data(){
    return{
      locale:{
        filterConfirm: '确定',
        filterReset: '重置',
        emptyText: '暂无数据'
      },
      data:[],
      detailsshow: false,
      detailssnum: [],
      statusText:['草稿','待审核','驳回','待发布','已发布']
    }
  },
  watch: {
    dataList() {
      this.data = this.dataList;
    },
    loading(val){
      this.loading=val
    }
  },
  methods:{
    //查看稿件信息
    titles(val) {
      // console.log(val);
      this.detailsshow = !this.detailsshow;
      this.detailssnum = val;
    },
    visible(val) {
      this.detailsshow = val;
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.$emit("handleTableChange", pagination, filters, sorter);
    },
    //发布
    release(text, record){
      this.loading=true

      let form = {
        id:record.id,
        status:1
      }
      updateArticle(form).then(res=>{
        if(res.status){
          this.$message.success('发布成功')
          this.$emit('getList')
          this.loading=false
        }
      })
    },
    //弹窗关闭
    cancel() {},
    //编辑
    async edit(text, record){
      sessionStorage.setItem("manuscript" ,JSON.stringify(record))
      await getArticleInfo({id:record.id}).then(res=>{
        if(res.status){
          sessionStorage.setItem("articleContent" ,JSON.stringify(res.data))
        }
      })
      this.$router.push('editarticle')
    },
    //撤回
    back(text, record){
      this.loading=true
      if(record.status==0){
        deleteArticle({id:record.id}).then(res=>{
          this.$emit('getList')
          this.loading=false
          if(this.tableStatus=="workbench"){
            this.$emit('getSubscribeCensus')
          }
        })
      }else{
        let form = {
          id:record.id,
          status:0
        }
        // form.status=0
        updateArticle(form).then(res=>{
          if(res.status){
            this.$emit('getList')
            this.loading=false
          }
        })
      }
      // console.log(record)
      // if(this.tableStatus=='drafts'){
      //   deleteArticle({id:record.id}).then(res=>{
      //     this.$emit('getList')
      //     this.loading=false
      //   })
      // }else{
      //   let form = {
      //     id:record.id,
      //     status:0
      //   }
      //   // form.status=0
      //   updateArticle(form).then(res=>{
      //     if(res.status){
      //       this.$emit('getList')
      //       this.loading=false
      //     }
      //   })
      // }
    },
    returnTime(val){
      return moment(val*1000).format('YYYY-MM-DD hh:mm:ss')
    },
    formatDate(value) {
      var date = new Date(value * 1000);
      var y = date.getFullYear(),
          m = date.getMonth() + 1,
          d = date.getDate(),
          h = date.getHours(),
          i = date.getMinutes(),
          s = date.getSeconds();
      if (m < 10) { m = '0' + m; }
      if (d < 10) { d = '0' + d; }
      if (h < 10) { h = '0' + h; }
      if (i < 10) { i = '0' + i; }
      if (s < 10) { s = '0' + s; }
      var t = y + '-' + m + '-' + d + ' ' + h + ':' + i + ':' + s;
      return t;

    },
  }
}
</script>

<style lang="scss" scoped>
.listmode {
  width: 100%;
  height: 100%;
  padding: 24px;
  padding-top: 0;
  box-sizing: border-box;
  /deep/.ant-table-tbody > tr > td {
    padding: 12px 20px;
  }

  .titletxt{
    white-space: nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
  // 修改分页器 已选中选项 样式
  /deep/.ant-pagination-item-active{
    border-color: #FF5E5D;
    background: #FF5E5D;
    a{
      color: white!important;
    }
  }
  // 修改分页器 未选中选项 样式
  /deep/.ant-pagination-item:focus,
  /deep/.ant-pagination-item:hover{
    border-color: $--governmentpeach;
    a{
      color: $--governmentpeach;
    }
  }
  /deep/.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon, /deep/.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon{
    color: $--governmentpeach;
  }
  /deep/.ant-pagination-prev .ant-pagination-item-link:hover, /deep/.ant-pagination-next .ant-pagination-item-link:hover{
    border-color: $--governmentpeach;
    color: $--governmentpeach;
  }
}
</style>